<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
.tooltip-content {
  width: 200px;
}
</style>



// WEBPACK FOOTER //
// src/App.vue